import { Component, OnInit, ViewChild } from '@angular/core';
import { UnassignedAssessmentsComponent } from '../unassigned-assessments/unassigned-assessments.component';
import { AssignedComponent } from '../assigned/assigned.component';
import { CoachCompletedAssessmentsComponent } from '../completed-assessments/completed-assessments.component';
import { ExpiredComponent } from '../expired/expired.component';
import { DownloadAssessmentManager } from '../../services/angular/DownloadAssessmentManager';
import { Globals } from '../../globals';
// import { setTimeout } from 'timers';
import { PurchaseAssessmentModalComponent } from '../../purchase-assessment-modal/purchase-assessment-modal.component';
import { AssignAssessmentModalComponent } from '../../assign-assessment-modal/assign-assessment-modal.component';
import { isUndefined } from 'util';
import { ArchivedAssessmentsComponent } from '../archived-assessments/archived-assessments.component';
import { AdminService } from '../../services/admin/AdminService';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-assessments',
    templateUrl: './assessments.component.html',
    styleUrls: ['./assessments.component.scss'],
    providers: [UnassignedAssessmentsComponent, AssignedComponent, CoachCompletedAssessmentsComponent, DownloadAssessmentManager, ExpiredComponent, ArchivedAssessmentsComponent]
})
export class CoachAssessmentsComponent implements OnInit {

    @ViewChild('purchaseAssessment', {static: true}) public purchaseAssessmentModal: PurchaseAssessmentModalComponent;
    @ViewChild('assignAssessment', {static: true}) public assignAssessmentModal: AssignAssessmentModalComponent;

    loading: boolean = true;
    currentSelectedTab: number = 0;
    pageName: string = "coach_assessments";

    constructor(
        private _UnassignedAssessmentsComponent: UnassignedAssessmentsComponent,
        private _AssignedComponent: AssignedComponent,
        private _CoachCompletedAssessmentsComponent: CoachCompletedAssessmentsComponent,
        private _ExpiredComponent: ExpiredComponent,
        private _ArchivedAssessmentsComponent: ArchivedAssessmentsComponent,
        public _Globals: Globals,
        private _AdminService: AdminService,
        private toastr: ToastrService,
    ) { }

    ngOnInit() {
        this.loadTabContent(2);
        if (this._Globals.showCompletedAssessments) {
            setTimeout(() => {
                $("#completedAssessmentsTab a").trigger("click");
                this.loadTabContent(2);
                $('#responsiveSelect').val('2-tab2');
                this._Globals.showCompletedAssessments = false;
            }, 2000);
        }
       
    }

    ngOnDestroy() {
        this._Globals.showCompletedAssessments = false;
    }

    onResize(event: any) {
        //console.log("Width: " , event.currentTarget.innerWidth);
        //console.log("Height: " , event.currentTarget.innerHeight);

        //if (event.currentTarget.innerWidth < 855) {
        //    console.log('assessment onResize', event.currentTarget.innerWidth);
        //    //$('.assessments h1').css("padding-bottom", "35px");
        //} else {
        //    $('.assessments h1').css("padding-bottom", "0px");
        //}
        $('h1').css("padding-bottom", "0px");

        if (event.currentTarget.innerWidth < 992) {
            $('#responsiveSelect option').eq(this.currentSelectedTab - 2).prop('selected', true);
        } else {
            console.log('set tab selected');
            this.openTab(this.currentSelectedTab + '-Tab' + this.currentSelectedTab);
            $('.desktopTabs ul li').removeClass('active');
            $('.desktopTabs ul li').eq(this.currentSelectedTab - 2).addClass('active');
        }
    }

    openTab(menu: string) {
        var res = menu.split("-");
        console.log('currentSelectedTab', res[0]);
        console.log('tab', res[1]);

        $(`.assessmentsComponent #assessmentsComponentTab1,
           .assessmentsComponent #assessmentsComponentTab2,
           .assessmentsComponent #assessmentsComponentTab3,
           .assessmentsComponent #assessmentsComponentTab4,
           .assessmentsComponent #assessmentsComponentTab5`).removeClass('active in');
        $('.assessmentsComponent #assessmentsComponent' + res[1]).addClass('active in');
        this.loadTabContent(res[0]);
    }

    loadTabContent(event: any) {

        event = parseInt(event);
        console.log('loadTabContent', event);
        this.currentSelectedTab = event;

        switch (event) {

            case 1: {
                //this._UnassignedAssessmentsComponent.sizeToFit(this._Globals.unassignedAssessmentGridApi);
                //$('.ag-body-viewport-wrapper').css("margin-top", "0px");
                this._UnassignedAssessmentsComponent.sizeToFit(this._Globals.unassignedAssessmentGridApi);
                $('h1').css("padding-bottom", "0px");
                this._UnassignedAssessmentsComponent.getCoachAvailableAssessmentsByType(1);
                this._UnassignedAssessmentsComponent.getCoachAvailableAssessmentsByType(2);
                this._UnassignedAssessmentsComponent.showAvailableTabs(); // this is for the responsive mode
                this._Globals.assessmentsTypeFlag = 0;
                break;
            }

            case 2: {
                if (!isUndefined(this._Globals.assignedAssessmentGridApi)) {
                    this._AssignedComponent.sizeToFit(this._Globals.assignedAssessmentGridApi);
                }
                
                if (this._AssignedComponent.getDisplayTagsCount() === 0) {
                    this._AssignedComponent.getCoachAssignedAssessmentsByType(1);
                } else {
                    this._AssignedComponent.reloadApplyingTagsFilter();
                }

                if (this._AssignedComponent.getDisplay360TagsCount() === 0) {
                    this._AssignedComponent.getCoachAssignedAssessmentsByType(2);
                } else {
                    this._AssignedComponent.reloadApplying360TagsFilter();
                }

                this._Globals.assignedAssessmentType = 1.1;
                this._Globals.assignedCanDelete = false;
                this._Globals.assignedCanCopy = false;
                this._Globals.assignedCanAddRaters = false;
                this._Globals.assignedCanUpdate = false;
                this._Globals.assignedCanSend = false;
                this._Globals.assignedCanSendReminder = false;
                this._Globals.assignedCanAddTags = false;
                //$('#assignedAssessments .ag-body-viewport-wrapper').css({ "margin-top": "-32px", "position": "absolute", "width": "100%", "height": "100%" });
                //$('#hideFilter').addClass('notShow');
                //$('#showFilter').addClass('show');
                //$('#hideFilter').removeClass('show');
                var w = window.innerWidth;
                if (w < 855) {
                    $('h1').css("padding-bottom", "35px");
                }
                this._AssignedComponent.showAssignedTabs();
                break;
            }

            case 3: {
                this._CoachCompletedAssessmentsComponent.sizeToFit(this._Globals.completedAssessmentGridApi);

                if (this._CoachCompletedAssessmentsComponent.getDisplayTagsCount() === 0) {
                    this._CoachCompletedAssessmentsComponent.getCoachCompletedAssessmentsByType(1);
                } else {
                    this._CoachCompletedAssessmentsComponent.reloadApplyingTagsFilter();
                }

                if (this._CoachCompletedAssessmentsComponent.getDisplay360TagsCount() === 0) {
                    this._CoachCompletedAssessmentsComponent.getCoachCompletedAssessmentsByType(2);
                } else {
                    this._CoachCompletedAssessmentsComponent.reloadApplying360TagsFilter();
                }

                this._Globals.completedCanEnableResults = false;
                this._Globals.completedCanArchiveAssessments = false;
                this._Globals.completedCanAddTags = false;
                //$('#completedAssessments .ag-body-viewport-wrapper').css({ "margin-top": "-32px", "position": "absolute", "width": "100%", "height": "100%" });
                //$('#cHideFilter').addClass('notShow');
                //$('#cShowFilter').addClass('show');
                //$('#cHideFilter').removeClass('show');
                $('h1').css("padding-bottom", "0px");
                this._CoachCompletedAssessmentsComponent.showCompletedTabs();
                break;
            }

            case 4: {
                this._ExpiredComponent.sizeToFit(this._Globals.expiredAssessmentGridApi);

                if (this._ExpiredComponent.getDisplayTagsCount() === 0) {
                    this._ExpiredComponent.getCoachExpiredAssessmentsByType(1);
                } else {
                    this._ExpiredComponent.reloadApplyingTagsFilter();
                }

                if (this._ExpiredComponent.getDisplay360TagsCount() === 0) {
                    this._ExpiredComponent.getCoachExpiredAssessmentsByType(2);
                } else {
                    this._ExpiredComponent.reloadApplying360TagsFilter();
                }

                this._Globals.expiredAssessmentType = 3.1;
                this._Globals.expiredCanDelete = false;
                this._Globals.expiredCanCopy = false;
                this._Globals.expiredCanAddRaters = false;
                this._Globals.expiredCanExtend = false;
                this._Globals.expiredCanSend = false;
                this._Globals.expiredCanSendReminder = false;
                this._Globals.expiredCanAddTags = false;
                //$('#assignedAssessments .ag-body-viewport-wrapper').css({ "margin-top": "-32px", "position": "absolute", "width": "100%", "height": "100%" });
                //$('#hideFilter').addClass('notShow');
                //$('#showFilter').addClass('show');
                //$('#hideFilter').removeClass('show');
                var w = window.innerWidth;
                if (w < 855) {
                    $('h1').css("padding-bottom", "30px");
                }
                this._ExpiredComponent.showExpiredTabs();
                break;
            }

            case 5: {
                this._ArchivedAssessmentsComponent.sizeToFit(this._Globals.archivedAssessmentGridApi);

                if (this._ArchivedAssessmentsComponent.getDisplayTagsCount() === 0) {
                    this._ArchivedAssessmentsComponent.getCoachArchivedAssessments(1);
                } else {
                    this._ArchivedAssessmentsComponent.reloadApplyingTagsFilter();
                }

                if (this._ArchivedAssessmentsComponent.getDisplay360TagsCount() === 0) {
                    this._ArchivedAssessmentsComponent.getCoachArchivedAssessments(2);
                } else {
                    this._ArchivedAssessmentsComponent.reloadApplying360TagsFilter();
                }

                this._Globals.canRestoreAssessments = false;
                $('h1').css("padding-bottom", "0px");
                this._ArchivedAssessmentsComponent.showArchivedTabs();
                break;
            }
        }

        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
            //this.loading = false;
        }, 500);

        //this.GetChoiceSets(event + 1); 

    }

    /*Purchase Modal*/
    openPurchaseModal() {
        //this._Globals.purchaseFromHome = true;
        this.purchaseAssessmentModal.show(this);
    }

    /*Assign Modal*/
    openAssignModal() {
        this.assignAssessmentModal.selectedAssessment = [];
        this.assignAssessmentModal.showAssignModal(this, 1);
    }

    getUserPersonalData() {
        $('body').css('cursor', 'wait');

        this._AdminService.getUserPersonalData(this._Globals.getUserId()).subscribe((data: any) => {
            console.log('response_getUserPersonalData', data);
            $('body').css('cursor', 'default');

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                $("input[name='first_name']").val(_data.vg6);
                $("input[name='last_name']").val(_data.hj7);
                $("input[name='user_email']").val(_data.sr3);
                $("input[name='contact_id']").val(_data.by3);

                if (_data.by3 != "0") {
                    this.ssoToShopify();
                }
                else {
                    this.toastr.warning('You are not authorized to access the requested page', "ELI");
                }
            }
        })
    }

    ssoToShopify() {

        var shopifyForm: any = document.getElementById('shopifyForm');
        shopifyForm.submit();
    }

}
